export default __webpack_public_path__ + "static/media/41881.9ecda786.jpg";